import { Pager } from './Pager';

export function setupPagers() {
  $('.pagination__pager').each((_, pager) => {
    new Pager($(pager));
  });
}
